// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary-3iej8","main":"main-10vuc","active":"active-3HFTk"};